/* eslint-disable @next/next/no-img-element */
import { Avatar, IconButton } from "@mui/material";
import { getAssets, newLineText } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import moment from "moment";
import { useState } from "react";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { MdSend } from "react-icons/md";
import { TfiMenu } from "react-icons/tfi";
import ScrollToBottom from "react-scroll-to-bottom";
import styles from "./message.module.scss";

export const MessageComponent = ({
  profileInfo,
  messages,
  setMessages,
  scrolref,
  currentChat = messages[0]?.receiver,
  getConnectedUserList,
  connectedUserList = false,
  chatId,
  socket,
  setArrivalMessage,
  closeDrawer,
  openDrawer,
}) => {
  //message state
  const [myMessages, setMyMessages] = useState("");
  const [loading, setLoading] = useState("");

  const addNewLineToTextArea = () => {
    let msg_text = myMessages + "\r\n";
    setMyMessages(msg_text);
  };
  //when press enter send message
  const handleKeyPress = (e) => {
    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      addNewLineToTextArea();
    } else if (
      e.keyCode === 13 &&
      e.target.value?.replace(/\s/g, "")?.length >= 1 &&
      !loading
    ) {
      handleSubmitMessage();
    }
  };
  // push new message

  const handleSubmitMessage = async () => {
    setLoading(true);

    await API.post("/chat-service/new-meessage", {
      uid: chatId,
      messages: myMessages,
      recieverId: connectedUserList?.find((item) => item?.uid == chatId)
        ?.receiver?.id,
      recieverType: "university",
      senderTime: new Date(),
    }).then(async (res) => {
      if (!res.error) {
        setMyMessages("");
        getConnectedUserList();
        setMessages((prev) => [
          ...prev,
          {
            id: res.data?.id,
            uid: res.data?.uid,
            studentId: res.data?.studentId,
            senderType: res.data?.senderType,
            universityId: res.data?.universityId,
            university: res.data?.university,
            mentorId: res.data?.mentorId,
            mentor: res.data?.mentor,
            recieverType: res.data?.recieverType,
            messages: res.data?.messages,
            createdAt: res.data?.createdAt,
            senderTime: res?.data?.senderTime,
          },
        ]);
        setArrivalMessage(null);
        socket.current.emit("send-message", {
          senderId: profileInfo?.id,
          receiverId: connectedUserList
            ?.find((item) => item?.uid == chatId)
            ?.receiver?.id?.toString(),
          text: myMessages,
          senderTime: new Date(),
        });
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  // rendar message
  const RenderMessage = (msgData) => {
    if (msgData?.is_first == 1) {
      return (
        <div
          className="chat_time"
          style={{
            fontSize: "13px",
          }}
        >
          {msgData?.messages}
        </div>
      );
    } else if (
      msgData &&
      msgData?.studentId === profileInfo?.id &&
      msgData?.senderType === "student"
    ) {
      return (
        <div className={styles.my_msg_wrapper}>
          {msgData?.senderTime && (
            <span className={styles.my_msg_time}>
              {/* <TimeAgo date={msgData?.senderTime} /> */}
              {moment(msgData?.senderTime).fromNow()}
              <div>{moment(msgData?.senderTime).format("hh:mm A")}</div>
            </span>
          )}
          <div className={styles.my_msg}>
            {newLineText(msgData?.messages)}
            {msgData?.is_read == 1 && (
              <IoCheckmarkDoneOutline className={styles.mark} />
            )}
          </div>
        </div>
      );
    }
    return (
      <div className={styles.buddy_msg_wrapper}>
        {msgData?.senderTime && (
          <span className={styles.msg_time}>
            {/* <TimeAgo date={msgData?.senderTime} /> */}
            {moment(msgData?.senderTime).fromNow()}
            <div>{moment(msgData?.senderTime).format("hh:mm A")}</div>
          </span>
        )}
        <div className={styles.msg_wrapper}>
          <div className={styles.image_wrapper}>
            <img
              style={
                msgData?.receiver?.userTypeSlug === "university"
                  ? { objectFit: "contain" }
                  : {}
              }
              src={
                msgData?.receiver?.media
                  ? msgData?.receiver?.media
                  : getAssets("assets/student-avatar-big.png")
              }
              alt="avatar"
            />
          </div>
          <div className={styles.replymsg}>
            {newLineText(msgData?.messages)}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.message_component_wrapper}>
      {currentChat && (
        <div className={styles.heading}>
          <TfiMenu className={styles.heading_menu} onClick={openDrawer} />
          {
            connectedUserList?.find((item) => item?.uid == chatId)?.receiver
              ?.name
          }
        </div>
      )}
      {messages && currentChat ? (
        <>
          <ScrollToBottom className={styles.conversation_wrapper}>
            <div className={styles.conversation_wrapper_child}>
              {messages &&
                messages?.length > 0 &&
                messages?.map((msgData, index) => {
                  return (
                    <div
                      key={(Math.random() + 1).toString(36).substring(7)}
                      className="chat_scroll"
                      id="chat_scroll"
                    >
                      {RenderMessage(msgData)}
                    </div>
                  );
                })}
            </div>
          </ScrollToBottom>
          <div className={styles.msg_footer_wrapper}>
            <div className={styles.action}>
              <div className={styles.left}>
                <div className={styles.image_wrapper}>
                  <Avatar
                    alt="profile"
                    src={
                      profileInfo?.profileImageSrc
                        ? profileInfo?.profileImageSrc
                        : getAssets("assets/student-avatar-big.png")
                    }
                  />
                </div>
                <textarea
                  aria-label="minimum height"
                  style={{ minHeight: "40px" }}
                  placeholder="Reply Message..."
                  value={myMessages ?? ""}
                  onChange={(e) => {
                    setMyMessages(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                    handleKeyPress(e);
                  }}
                />
              </div>
              <div className={styles.action_btn}>
                <IconButton
                  disabled={
                    myMessages?.replace(/\s/g, "")?.length >= 1 ? false : true
                  }
                  onClick={handleSubmitMessage}
                >
                  <MdSend />
                </IconButton>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className={styles.details_wrapper2}>
          <div className={styles.empty_detail_wrapper}>
            <div>Select a chat or start a new conversation</div>
            <button
              onClick={openDrawer}
              className={`btn btn-outline-grey btn-sm`}
            >
              Start
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageComponent;
